export default __webpack_public_path__ + "static/media/Spectrum-DesignAPI.4054a981.png";